// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3mj72","text":"SelectPayment_text__1iQX0","title":"SelectPayment_title__uEcM9","btn":"SelectPayment_btn__2kqNX"};